//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchConstraint.js";
import "../no/Expression.js";
import "../no/Sketch.js";
import "../no/ugmath.js";
let d=[[[0,"AssociatedDimension",0,"Annotations.Dimension",0],[1,"AssociatedExpression",0,"Expression",0],[0,"DimensionState",0,0]],[[["num_geom"],"GetDimensionGeometry",{R_:{geoms:""}},0,0],[[],"UseAlternateSolution",{},0,0],[[],"SetAsDriving",{},0,0],[[],"RemoveDrivingExpression",{},0,0],[["newDimValue"],"EditDimensionValue",{},1,0],[["preference"],"SetEndBehaviorPreference",{},1,0],[[],"AlternateAngle",{},0,0]],[]];
SPLM.SketchDimensionalConstraint = class extends SPLM.SketchConstraint{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchDimensionalConstraint";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchDimensionalConstraint.DimensionStateType = Object.freeze({
    "Driving" : "Driving", "Reference" : "Reference", "Automatic" : "Automatic", "Constant" : "Constant", "Preview" : "Preview"});

SPLM.SketchDimensionalConstraint.EndBehaviorPreference = Object.freeze({
    "Any" : "Any", "Geometry1Moves" : "Geometry1Moves", "Geometry2Moves" : "Geometry2Moves"});

export default SPLM;